/* eslint-disable no-unused-vars */
import { affiliatesState } from 'src/core/models/affiliate-center.interface'

const offersState: affiliatesState = {
  affiliate: {
    referral_code: '',
    purchases_count: 0,
    purchases_revenue: 0,
    created: '',
    modified: '',
    affiliate_percentage: 0.05,
    user: null,
  }
}

export { offersState as initialState }
